import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  createCustomField,
  editFormInputField,
  getFormInputFieldById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import Input from "../../Input/Input";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
// import { data } from "./CustomField.config";
import "./CustomField.scss";
import { CreateConfig } from "./CustomField.config";
import { useModalContext } from "../../Reactportal/ModalContext";

export const CustomField = ({ show, TypeOfPortal, setOpenCustomFieldForm, getFormSectionAndFields, ParentFormKey }) => {
  const formRef = useRef({});
  const Form_Key = "Custom_Fields12345";
  console.log(TypeOfPortal, show,Form_Key,"modalStackmodalStackmodalStackmodalStack");
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.[Form_Key]?.Selected_Row;
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [toggle, setToggle] = useState(show);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [options, setOptions] = useState(["", ""]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const [Active, setActive] = useState(false);
  const [data, setData] = useState(CreateConfig(ParentFormKey));
  const dispatch = useDispatch();
  const { pushModal, popModal, getTopModal } = useModalContext();
  // Q & M
  const [CreatingData, { loading: createLoading }] = useMutation(createCustomField);
  const [EditingData, { loading: editLoading }] = useMutation(editFormInputField);
  const [GetDataByID] = useLazyQuery(getFormInputFieldById, { fetchPolicy: "network-only" });

  const FormLoadingState = createLoading || editLoading;

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      console.log(fielddata);
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        console.log(data, "data");
        setActive(data?.getFormFieldById?.Active);
        let FormFieldData = {
          ...data?.getFormFieldById,
        };

        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Section_Id: FormFieldData?.Section_Id,
            },
          },
        });
        FormFieldData.Section_Id = FormFieldData?.Section_Id?.name;
        if (FormFieldData?.dropdowncontent?.length > 0) {
          setOptions(FormFieldData?.dropdowncontent || ["", ""]);
        }
        updateValueForm(formRef, FormFieldData);
        setAllFieldsData(FormFieldData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);
  useEffect(() => {
    console.log(show);
    setToggle(show);
    if (show) {
      pushModal(Form_Key);
    }
  }, [show]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Custom_Fields?.Selected_Rows);
  }, [fielddataRedux]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const { executeOperation } = useSubmitOperation();
  let operationType = TypeOfPortal == "Change_Status" ? "Edit" : TypeOfPortal;

  console.log(FormData, Active);
  let formData = TypeOfPortal == "Change_Status" ? { Active: !Active } : FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
  };
  // 6303469572
  const submit = async (closeAction) => {
    if (TypeOfPortal !== "Change_Status") {
      formData.Section_Id = FormDataFromRedux?.MasterData[Form_Key]?.Section_Id?._id;
    }
    options[0] !== "" && FormData?.type === "Dropdown" && (formData.dropdowncontent = options);
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
          setOptions(["", ""]);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {
        setOptions(["", ""]);
        getFormSectionAndFields();
        if (operationType === "Edit" || operationType === "Delete") {
          dispatch({ type: "Refetch", payload: true });
        }
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = useCallback(() => {
    console.log("Close function");
    setToggle(false);
    setAllFieldsData({});
    setOptions(["", ""]);
    setOpenCustomFieldForm(false);
    ClearSpecificForm(dispatch, Form_Key);
    popModal(Form_Key);
  }, []);

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const addOption = () => {
    setOptions([...options, ""]);
  };

  const removeOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      Form_key={Form_Key}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
              Validate_handleSubmit(SaveAndCloseForAdd);
            }
          : () => {
              Validate_handleSubmit(submit);
            }
      }
      handleformclose={() => {
        Closeformfunction();
      }}
      loadingState={FormLoadingState}
    />
  );

  if (TypeOfPortal === "Change_Status") {
    return (
      <Reactportal open={toggle} onClose={() => setToggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Change the Status of this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm"}
          handleformclose={() => {
            setToggle(!toggle);
          }}
          loadingState={FormLoadingState}
        />
      </Reactportal>
    );
  }

  return (
    <>
      <Reactportal FoooterContent={footerContent} open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal}>
        {FormLoadingState && <div className="loader-line-div" />}
        <div className="formContainer">
          {data &&
            data.map((e) => {
              console.log(e.fields);
              return (
                <>
                  <div className="">
                    <FormInputSectionComponent
                      TypeOfPortal={TypeOfPortal}
                      inputfields={e.fields}
                      onErrorsChange={handleErrorsChange}
                      onhandleFormikChange={HanldeChangeonForm}
                      Type={e.name}
                      formkey={Form_Key}
                      formRef={formRef}
                    />
                  </div>
                  {FormData?.type === "Dropdown" && (
                    <>
                      <div className="form-group">
                        <div className="dropdown-label">Dropdown Options:</div>
                        {options.map((option, index) => (
                          <div key={index} className="option-input">
                            <Input
                              type="text"
                              value={option}
                              handleInputChange={(e) => handleOptionChange(index, e.target.value)}
                              modalform={true}
                            />
                            {options.length > 2 && (
                              <RxCross2 className="cross-Icon" onClick={() => removeOption(index)} />
                            )}
                          </div>
                        ))}
                        <div>
                          <Button name="modalbutton" text=" Add Option" action={addOption} />
                        </div>
                      </div>
                    </>
                  )}
                </>
              );
            })}
        </div>
      </Reactportal>
    </>
  );
};
